module.exports = __webpack_public_path__ + "img/4.05.d9a8275a.jpg";